module.exports = __webpack_public_path__ + "MitekMobileWeb.worker.js";